export default __webpack_public_path__ + "static/media/tesla-now-1.5b944608.png";